module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_7042.bf1228e8.png";